module.exports = __webpack_public_path__ + "ac0672d4a28ca0241a9bf7a9cfbfb270.jpg";